"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
/**
 * Local Imports
 */

/**
 * MarqueePicture Component.
 * @module MarqueePicture
 *
 * @param {Object} props React props
 * @param {Object} props.landscape Desktop Image
 * @param {Object} props.tabletPortraitBackground Tablet Image
 * @param {Object} props.portrait Mobile Image
 * @param {String} props.imgLoading Lazy loading control: eager or lazy.
 * @returns {React.ReactElement} MarqueePicture Component
 * @public
 */

function MarqueePicture({
  portrait = {},
  landscape = {},
  tabletPortraitBackground = {},
  imgLoading = 'eager'
}) {
  return /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: landscape?.url,
    defaultAltText: landscape?.altText,
    width: landscape?.width,
    height: landscape?.height,
    loading: imgLoading
  }, portrait?.url && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: portrait.url,
    media: `${_patternLibraryUtils.deviceMax.mobileLg} and ${_patternLibraryUtils.orientation.portrait}`
  }), tabletPortraitBackground?.url && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: tabletPortraitBackground.url,
    media: landscape?.url ? `${_patternLibraryUtils.device.tablet} and ${_patternLibraryUtils.deviceMax.tabletLg} and ${_patternLibraryUtils.orientation.portrait}` : `${_patternLibraryUtils.device.tablet}`
  }), landscape?.url && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: landscape.url,
    media: `${_patternLibraryUtils.device.tablet} and ${_patternLibraryUtils.orientation.landscape}, ${_patternLibraryUtils.device.laptopMd}`
  }));
}
var _default = exports.default = MarqueePicture;
MarqueePicture.propTypes = {
  portrait: _propTypes.default.shape(_image.LazyPicture.propTypes),
  tabletPortraitBackground: _propTypes.default.shape(_image.LazyPicture.propTypes),
  landscape: _propTypes.default.shape(_image.LazyPicture.propTypes),
  imgLoading: _propTypes.default.oneOf(['lazy', 'eager'])
};